<template>
  <div class="container-fluid px-2">
    <div class="skeleton skeleton-title mb-3" style="width: 150px; height: 2rem;"></div>
    
    <!-- Row 1 -->
    <div class="row g-3">
      <div class="col-6 col-md-4 col-xl" v-for="i in count" :key="'row1-' + i">
        <div class="card h-100 shadow-sm">
          <div class="card-body border border-2 rounded-3">
            <div class="d-flex justify-content-between align-items-center">
              <div class="flex-grow-1">
                <div class="skeleton skeleton-text mb-2" style="width: 70%;"></div>
                <div class="skeleton skeleton-title" style="width: 40%; height: 2rem;"></div>
              </div>
              <div class="skeleton skeleton-avatar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonStats',
  props: {
    count: {
      type: Number,
      default: 5
    }
  }
};
</script>

<style scoped>
/* Component-specific skeleton styles */
</style>
